<template>
    <span v-show="isShowPage">
        <v-row align="center" justify="center">
            <v-spacer></v-spacer>
        </v-row>

        <v-row>
            <v-col class="pt-0">
                <Table :headers="headers" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable"
                    :defaultSize="10" :loading="isFetching" :showPagination="false">
                    <template slot="kategori" slot-scope="{ item }">
                        {{ capitalize(item.kategori) }}
                    </template>
                    <template slot="evCharger" slot-scope="{ item }">
                        {{ capitalize(item.evCharger) }}
                    </template>
                </Table>
            </v-col>
        </v-row>
        <v-row v-if="items && items.totalElements > 0">
            <v-col class="mt-5" cols="8">
                Menampilkan
                <v-select v-model="currentSize" :items="sizeOptions" dense solo flat class="ml-1 mr-1 size-select"
                    @change="onChangeSize"></v-select>
                data dari <b>{{ items.totalElements }}</b>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right mt-5">
                <v-pagination v-model="currentPage" :length="items.total || 1" :total-visible="5"
                    @input="onChangePage"></v-pagination>
            </v-col>
        </v-row>
    </span>
</template>
<script>
import Table from '../../components/Table.vue'
import MonitoringService from '@/services/default/MonitoringService'
import alert from '@/commons/helper/alert.helper'
import { GlobalStateMixins } from '@/mixins/mixins'

const monitoringService = MonitoringService.build()
export default {
    name: 'monitoring-antrian',
    components: {
        Table
    },
    mixins: [GlobalStateMixins],
    data: () => ({
        colorActive: '#2671D9',
        colorInactive: '#9A9A9A',
        headers: [
            { value: 'number', text: 'No.', sortable: false, align: 'center', width: '60px' },
            { value: 'spkluId', text: 'SPKLU ID', align: 'left', width: '100px' },
            { value: 'spkluName', text: 'Lokasi SPKLU', align: 'left' },
            { value: 'kategori', text: 'Kategori', align: 'center', width: '150px' },
            { value: 'evCharger', text: 'EV Charger', align: 'center' },
            { value: 'dayaCharger', text: 'Daya Charger', align: 'left', width: '120px' },
            { value: 'connector', text: 'Connector', align: 'center', width: '100px' },
            { value: 'kwhPembelian', text: 'kWh Pembelian', align: 'center', width: '130px' },
            { value: 'remainingTimeSeconds', text: 'Estimasi durasi charging (remaining time)', align: 'center', width: '130px' },
            { value: 'jumlahAntrean', text: 'Jumlah Antrean', align: 'center', width: '130px' },
            { value: 'uidUiw', text: 'UID/UIW', align: 'center', width: '230px' },
            { value: 'up3', text: 'UP3', align: 'center' },
            { value: 'ulp', text: 'ULP', align: 'center' },
            { value: 'provinsi', text: 'Provinsi', align: 'center', width: '150px' },
            { value: 'pemdaPemkot', text: 'Pemda/Pemkot', align: 'left' }
        ],
        items: {
            data: [],
            total: 0,
            size: 10,
            page: 1,
            totalElements: 0
        },

        search: '',
        sortSettings: '',
        isShowPage: true,
        isFetching: false,
        timer: '',
        paging: {
            page: 0,
            size: 10
        },
        currentPage: 1,
        currentSize: 10,
        sizeOptions: [5, 10, 20, 30, 50]
    }),
    async created() {
        localStorage.removeItem('tableQuery')
        this.paging.page = 0
        this.paging.size = 10
        this.currentSize = 10
        this.getDataTable()
    },
    computed: {},
    mounted: function () {
        this.$nextTick(() => {
            this.timer = setInterval(() => {
                try {
                    const tableQueryStr = localStorage.getItem('tableQuery')
                    const tableQuery = tableQueryStr ? JSON.parse(tableQueryStr) : null
                    if (tableQuery && tableQuery.page !== undefined && tableQuery.size !== undefined) {
                        this.getDataTable(tableQuery.page, tableQuery.size)
                    } else {
                        this.getDataTable(0, 10)
                    }
                } catch (error) {
                    console.error('Error parsing tableQuery:', error)
                    this.getDataTable(0, 10)
                }
            }, 60000)
        })
    },
    destroyed: function () {
        clearInterval(this.timer)
    },
    watch: {
        search: function (val) {
            if (val === '') {
                this.getDataTable()
            }
        },
        items: function (val) {
            if (val && val.page) {
                this.currentPage = val.page
            }
        },
        currentSize: function (newVal) {
            if (this.paging.size !== newVal) {
                this.paging.size = newVal
            }
        }
    },
    methods: {
        async resetData() {
            this.items = {
                data: [],
                total: 0,
                size: 10,
                page: 1,
                totalElements: 0
            }
            this.sortSettings = ''
        },
        async getDataTable(page, size) {
            this.isFetching = true

            if (page !== undefined) {
                this.paging.page = page
            } else {
                this.paging.page = this.paging.page || 0
            }
            if (size !== undefined) {
                this.paging.size = size
            } else {
                this.paging.size = this.paging.size || 10
            }

            try {
                let tableQueryStr = localStorage.getItem('tableQuery')
                let tableQuery = tableQueryStr ? JSON.parse(tableQueryStr) : null

                localStorage.setItem('tableQuery', JSON.stringify({
                    page: this.paging.page,
                    size: this.paging.size,
                    sort_by: tableQuery ? tableQuery.sort_by : ''
                }))

                tableQueryStr = localStorage.getItem('tableQuery')
                tableQuery = tableQueryStr ? JSON.parse(tableQueryStr) : null

                const param = {
                    page: this.paging.page,
                    size: this.paging.size
                }

                const response = await monitoringService.getListAntrian(param)

                if (response && response.data && response.data.status === 200) {
                    const { data: { data: { items, page, totalPages, rows, totalRows } } } = response
                    const actualSize = this.paging.size
                    const itemsToDisplay = items || []

                    this.items = Object.assign({
                        data: itemsToDisplay,
                        total: totalPages || 0,
                        size: actualSize,
                        page: (page !== undefined ? page : 0) + 1,
                        totalElements: totalRows || 0
                    })
                    this.currentSize = actualSize
                } else {
                    const errorMsg = response && response.data ? (response.data.status + ' - ' + response.data.message) : 'Terjadi kesalahan saat mengambil data'
                    alert.failed(errorMsg)
                    this.items = {
                        data: [],
                        total: 0,
                        size: this.paging.size,
                        page: 1,
                        totalElements: 0
                    }
                }
            } catch (error) {
                console.error('Error in getDataTable:', error)
                alert.failed('Terjadi kesalahan saat mengambil data')
                this.items = {
                    data: [],
                    total: 0,
                    size: this.paging.size,
                    page: 1,
                    totalElements: 0
                }
            } finally {
                this.isFetching = false
            }
        },
        async updateSortDatatable(options) {
            if (options.sortBy) {
                this.sortSettings = ''
                for (let i = 0; i < options.sortBy.length; i++) {
                    const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
                    let column = ''

                    if (options.sortBy[i] === 'spkluId') {
                        column = 'spkluId'
                    } else if (options.sortBy[i] === 'spkluName') {
                        column = 'spkluName'
                    } else if (options.sortBy[i] === 'kategori') {
                        column = 'kategori'
                    } else if (options.sortBy[i] === 'evCharger') {
                        column = 'evCharger'
                    } else if (options.sortBy[i] === 'dayaCharger') {
                        column = 'dayaCharger'
                    } else if (options.sortBy[i] === 'connector') {
                        column = 'connector'
                    } else if (options.sortBy[i] === 'kwhPembelian') {
                        column = 'kwhPembelian'
                    } else if (options.sortBy[i] === 'jumlahAntrean') {
                        column = 'jumlahAntrean'
                    } else if (options.sortBy[i] === 'provinsi') {
                        column = 'provinsi'
                    } else if (options.sortBy[i] === 'pemdaPemkot') {
                        column = 'pemdaPemkot'
                    }

                    if (i === 0) {
                        this.sortSettings += column + ',' + sort
                    } else {
                        this.sortSettings += '&sort=' + column + ',' + sort
                    }
                }

                try {
                    let tableQueryStr = localStorage.getItem('tableQuery')
                    let tableQuery = tableQueryStr ? JSON.parse(tableQueryStr) : null
                    localStorage.setItem('tableQuery', JSON.stringify({
                        page: tableQuery ? tableQuery.page : 0,
                        size: tableQuery ? tableQuery.size : 10,
                        sort_by: this.sortSettings
                    }))
                    tableQueryStr = localStorage.getItem('tableQuery')
                    tableQuery = tableQueryStr ? JSON.parse(tableQueryStr) : null
                    this.getDataTable(tableQuery ? tableQuery.page : 0, tableQuery ? tableQuery.size : 10)
                } catch (error) {
                    console.error('Error in updateSortDatatable:', error)
                    this.getDataTable(0, 10)
                }
            }
        },
        onChangePage(page) {
            this.getDataTable(page - 1, this.currentSize)
        },
        onChangeSize(size) {
            const newSize = parseInt(size, 10)
            this.currentPage = 1
            this.currentSize = newSize
            this.paging.size = newSize
            this.paging.page = 0
            this.getDataTable(0, newSize)
        }

    }
}
</script>
<style scoped>
.search {
    height: 48px;
}
</style>
